import  React, { useEffect, useState } from 'react';
import { IonContent, IonPage, } from '@ionic/react';

import { useAuth0 } from "@auth0/auth0-react";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import useStyles from '../assets/cssClasses';
import { Capacitor } from '@capacitor/core';
import { 
  Toolbar, 
  Grid, 
} from '@material-ui/core';   

   import {firebase} from '../assets/firebase'

   interface dbProps {
    ios: Boolean,
  }

const About: React.FC<dbProps> = (props) => {
    const { loginWithRedirect, logout, user, isAuthenticated } = useAuth0();
    const classes = useStyles();

    const [infoContent, setInfoContent] = useState<string>('');

    useEffect(()=>{
        var store = firebase.storage()
        
        store.ref('/pages/info.txt').getDownloadURL().then(function(url){
               console.log(url);
               var xhr = new XMLHttpRequest();
                xhr.responseType = 'text';
                xhr.onload = function(event) {
                    setInfoContent(xhr.response);
                };
                xhr.open('GET', url);
                xhr.send();
            });
            
    
         
    },[])
  
  return (
    <IonPage>
      <IonContent>
      
        <Grid container spacing={2}>
        <Grid item xs={12}>
            <AppBar className={props.ios?classes.page_title_ios:classes.page_title} position="sticky">
              <Toolbar>
                <Typography className={classes.title} variant="h6">
                  <span className={classes.left_align_block}>Bright DSM | About
                  {isAuthenticated &&
                      <span> | {user.email}</span>
                    }
                  </span>
                  <span className={classes.right_align_block}>
                    {!isAuthenticated && !Capacitor.isNative &&
                      <Button onClick={() => loginWithRedirect()} className={classes.actionButton}>Log In as Admin</Button>
                    }
                    {isAuthenticated && !Capacitor.isNative &&
                      <Button onClick={() => logout({ returnTo: window.location.origin })} className={classes.actionButton}>Log Out</Button>
                    }
                  </span>
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>
          <Grid item xs={12}>
            <div dangerouslySetInnerHTML={{__html: infoContent}} />
          </Grid>
        </Grid>
      </IonContent>
      </IonPage>

  );
};

export default About;
